import { Observable } from 'rxjs';

import UserApi from 'entities/user/api';
import { showMessageAction, showErrorAction } from 'containers/Notification/actions';
import DeedsApi from 'entities/deed/api';

import {
  searchSuccessAction,
  searchFailedAction,
  inviteAttendeesFailedAction,
  inviteAttendeesSuccessAction,
} from './actions';
import { INVITE_ATTENDEES, SEARCH } from './constants';

const inviteAttendees = (action$) =>
  action$.ofType(INVITE_ATTENDEES).mergeMap(({ deedId, users, emails }) =>
    DeedsApi.inviteAttendees(deedId, users, emails)
      .mergeMap((resultingAction) => [
        resultingAction,
        showMessageAction('Invited attendees!'),
        inviteAttendeesSuccessAction(),
      ])
      .catch((e) =>
        Observable.of(inviteAttendeesFailedAction(e), showErrorAction('Invite Attendees Failed!'))
      )
  );

const search = (action$) =>
  action$.ofType(SEARCH).switchMap(({ term }) => {
    if (term.length < 2) {
      return [];
    }
    return UserApi.search(term)
      .takeUntil(action$.ofType(SEARCH))
      .mergeMap((results) => [searchSuccessAction(results)])
      .catch((e) => Observable.of(searchFailedAction(e)));
  });

export default [search, inviteAttendees];
